import { storeToRefs } from 'pinia';
import type { Ref } from 'vue';
import { computed } from 'vue';
import { useEventCountdown } from '@/composable/useEventCountDown';
import { ShowTimeDisplayType } from '@/interface/enum';
import { useToggleStore } from '@/store/toggleStore';

interface IEPenaltyEventCountdown {
    showTimeType: number;
    realKickoffTime: Date;
    isLive: boolean;
    league: {
        id: number;
    };
}

export function useEPenaltyEventCountdown(
    event: Ref<IEPenaltyEventCountdown | null>,
) {
    const { countdownDisplay, isShowCountdownHours, timeDifference } = useEventCountdown(event);

    const { ePenaltyLeagueIds } = storeToRefs(useToggleStore());

    const isShowCountdown = computed(() => {
        if (!event.value) {
            return false;
        }

        if (event.value.showTimeType === ShowTimeDisplayType.Date) {
            return false;
        }

        const remainingSeconds = timeDifference.value.totalSeconds;
        return ePenaltyLeagueIds.value.includes(event.value.league.id) && remainingSeconds > 0;
    });

    return {
        countdownDisplay,
        isShowCountdownHours,
        isShowCountdown,
    };
}
